import React, { MouseEvent } from 'react';
import { Link, LinkProps } from 'react-router-dom';

type PropsType = Omit<LinkProps, 'to'> & {
  to?: string | null;
  stopPropagation?: boolean;
};

// Renders a real <a href>, so ctrl/cmd+click, middle-click and the browser's
// "open in new tab" context menu work natively, while a plain left click still
// does an in-app SPA navigation via react-router's Link.
const TFLink = ({
  to,
  stopPropagation = true,
  onClick,
  children,
  className,
  ...rest
}: PropsType) => {
  if (!to) {
    return <span className={className}>{children}</span>;
  }

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (stopPropagation) e.stopPropagation();
    onClick?.(e);
  };

  return (
    <Link to={to} className={className} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
};

export default TFLink;
